import React from 'react'
import ToggleInput from './ToggleInput'

const ToggleFieldInput = ({ label, boldColours, secondLabel, containerClassName, switchContainerClassName, id, onChange, name, checked, onClick, thirdLabelClassName }) => {
	
		let labelClassname = "mr-2 toggle-label";
		let secondLabelClassname = "mr-1 toggle-label";

		if (secondLabel && checked) {
			secondLabelClassname += " toggle-label__inactive";
			labelClassname += " toggle-label__active";
		} else if (secondLabel && !checked) {
			labelClassname += " toggle-label__inactive";
			secondLabelClassname += " toggle-label__active";
		}

		return ( 
			<div className={containerClassName}>
				{secondLabel &&
					<label className={secondLabelClassname}>{secondLabel}</label>
				}
				<ToggleInput
					id={id}
					boldColours={boldColours}
					secondLabel={secondLabel}
					onChange={onChange}
					name={name}
					onClick={onClick} 
					checked={checked}
					switchContainerClassName={switchContainerClassName}
				/>
				<label className={`${labelClassname}${thirdLabelClassName ? ' ' + thirdLabelClassName : ''}`} htmlFor={id}>
					{label}
				</label>
			</div>
		 );
}
 
export default ToggleFieldInput;